import { slalomHandlers } from "./slalom.js";
import { raceHandlers } from "./race.js";
import { trainingHandlers } from "./training.js";

// SessionType -> handler set. Types 3-6 (Gleichmaessigkeit, Additionsergebnis,
// Gleichmaessigkeit 2, SlalomRallye) have no handlers yet, matching the
// no-op behaviour of their previously empty switch-cases in functions.js.
export const sessionHandlers = {
  0: slalomHandlers, // Slalom
  1: raceHandlers, // Rennen
  2: trainingHandlers, // Training
};
